import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../ui/button";
import ConfirmModal from "../PaidUsers/ConfirmModal";
import { cancelOrder } from "@/lib/placeOrder";
import { resetStocksDetails } from "@/store/features/stocksDetailsSlice";
import { capitalized } from "@/lib/utils";
import { setOpenModifyOrderSlice, setOpenPlaceOrderSlice, updateMultiField } from "@/store/features/placeOrderSlice";
import { setOpenGTTBfSlice } from "@/store/features/gttBfSlice";
import { toast } from "sonner";
import { fetchGttOrderBook, fetchOrderDetails } from "@/store/features/ordersSlice";

export default function StockDetailsFooter() {
    const dispatch = useDispatch();
    const {
        finCode,
        scripData,
        footerButton,
        orderDetails,
        gttDetails,
        positionsDetails,
        holdingDetails,
        data,
        stockDetails
    } = useSelector((state) => state.stocksDetails);
    const exchange = scripData?.exchange ?? holdingDetails?.primaryExchange;

    return (
        <div className="sticky bottom-0 left-0 right-0 font-Inter bg-white shadow-[0px_0px_8px_0px_rgba(0,0,0,0.1)]">
            <div className="p-4 flex items-center gap-4">
                {footerButton?.map(({ variant, type, text, isGtt }, index) =>
                    type === "CANCEL" ? (
                        <ConfirmModal
                            key={index}
                            onConfirm={(e) => {
                                e.stopPropagation();
                                cancelOrder(orderDetails?.order_no ?? gttDetails?.order_number, isGtt).then((res) => {
                                    toast.success("Order cancellation request submitted successfully.");
                                    dispatch(resetStocksDetails());
                                    dispatch(fetchGttOrderBook());
                                    dispatch(fetchOrderDetails(true));
                                });
                            }}
                            header={`Are you sure you want to cancel?`}
                        >
                            <Button key={index} variant={variant} className="text-base font-bold h-12 rounded-lg">
                                {capitalized(text)}
                            </Button>
                        </ConfirmModal>
                    ) : (
                        <Button
                            key={index}
                            variant={variant}
                            className="text-base font-bold h-12 rounded-lg"
                            onClick={() => {
                                if (type === "BUY" || type === "SELL") {
                                    if (isGtt) {
                                        cancelOrder(orderDetails?.order_no ?? gttDetails?.order_number, isGtt).then(
                                            (res) => {
                                                setOpen(false);
                                                toast.success("Order cancellation request submitted successfully.");
                                                dispatch(fetchGttOrderBook());
                                            }
                                        );
                                    } else {
                                        dispatch(
                                            setOpenPlaceOrderSlice({
                                                isOpen: true,
                                                type,
                                                finCode,
                                                exchange,
                                                source: ""
                                            })
                                        )
                                            .unwrap()
                                            .then((e) => {
                                                // console.log({ productType: positionsDetails?.productType });
                                                if (positionsDetails?.productType) {
                                                    dispatch(
                                                        updateMultiField({
                                                            productType: positionsDetails?.productType,
                                                            quantity:
                                                                positionsDetails?.net_qty > 0 ||
                                                                positionsDetails?.net_qty < 0
                                                                    ? Math.abs(
                                                                          positionsDetails?.net_qty /
                                                                              positionsDetails?.lot_size
                                                                      ).toString()
                                                                    : 1
                                                        })
                                                    );
                                                }
                                            });
                                    }
                                } else if (type === "MODIFY") {
                                    if (isGtt) {
                                        dispatch(
                                            setOpenGTTBfSlice({
                                                isOpen: true,
                                                scriptCode: gttDetails?.security_id,
                                                totalQty: gttDetails?.total_quantity,
                                                orderId: gttDetails?.order_number,
                                                stopLoss: gttDetails?.stop_loss,
                                                targetPrice: gttDetails?.target,
                                                exchange: gttDetails?.exchange,
                                                symbol: gttDetails?.symbol,
                                                hasGtt: true,
                                                segment: gttDetails?.segment,
                                                exch_id: gttDetails?.txn_type,
                                                txnType: gttDetails?.txn_type,
                                                product: gttDetails?.product
                                            })
                                        );
                                    } else {
                                        dispatch(
                                            setOpenModifyOrderSlice({
                                                finCode: stockDetails?.finCode,
                                                ...orderDetails,
                                                ...data,
                                                source: ""
                                            })
                                        );
                                    }
                                } else if (type === "RE") {
                                    dispatch(
                                        setOpenModifyOrderSlice({
                                            finCode: stockDetails?.finCode,
                                            ...orderDetails,
                                            ...data,
                                            order_no: null,
                                            source: ""
                                        })
                                    );
                                }
                            }}
                        >
                            {capitalized(text)}
                        </Button>
                    )
                )}
            </div>
        </div>
    );
}
